module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/align-right-866c26dfce9bb6251968fa803b6ac42d.svg";